import { connect } from "react-redux"
import BsrComplianceToggle from "."
import { toggleBsrCompliance } from "../../store"

const mapStateToProps = ({ bsrCompliance: { bsrCompliance } }) => ({
  bsrCompliance,
})

const mapDispatchToProps = dispatch => ({
  onChange: () => {
    dispatch(toggleBsrCompliance)
  },
})

const BsrComplianceToggleWithStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(BsrComplianceToggle)

export default BsrComplianceToggleWithStore
